import { render, staticRenderFns } from "./publish-product-form-checkbox.vue?vue&type=template&id=5aa9a1c4&scoped=true&"
import script from "./publish-product-form-checkbox.vue?vue&type=script&lang=js&"
export * from "./publish-product-form-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./publish-product-form-checkbox.vue?vue&type=style&index=0&id=5aa9a1c4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa9a1c4",
  null
  
)

export default component.exports